module.exports = __webpack_public_path__ + "static/img/fnj-logo.56640a2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/fnj-logo.png
// module id = RjwV
// module chunks = 167